module.exports = __webpack_public_path__ + "./Danny2_9cbacf1f01c76cb7a023942c0ca8bd93.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Danny2.png
// module id = 551
// module chunks = 0